import { render, staticRenderFns } from "./RcpyN_Details.vue?vue&type=template&id=781c1bec"
import script from "./RcpyN_Details.vue?vue&type=script&lang=js"
export * from "./RcpyN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports